import React, { Component } from 'react'
import { connect } from 'react-redux'
import { currentUserStart, logoutStart } from '../redux/modules/user'
import Footer from '../components/common/Footer'
import Header from '../components/common/Header'
import { SimpleSpinner } from '../components/common/SimpleSpinner'
import { loadProfileStart } from '../redux/modules/profile'
import { selectUserLocationId } from '../redux/modules/selectors'
import { pushGTMUserInfo } from '../util/gtmUtils'

export const HeaderComponent = ({
  currentUser,
  isAuthenticated,
  locationId,
  isCurrentUserLoading,
  profile,
  match,
  history,
  requestCount,
  showSubNav,
}) => {
  if (currentUser) {
    return (
      <Header
        avatarId={profile && profile.avatarId}
        currentUser={currentUser}
        history={history}
        isAuthenticated={isAuthenticated}
        isCurrentUserLoading={isCurrentUserLoading}
        locationId={locationId}
        logout={logoutStart}
        match={match}
        profileStatus={profile && profile.status}
        requestCount={requestCount}
        showOffersButton
        showSubNav={showSubNav}
      />
    )
  } else {
    return <Header match={match} />
  }
}

export class LayoutOneCol extends Component {
  componentDidMount() {
    this.props.currentUserStart(true, true)
    if (this.props.currentUser) {
      this.props.loadProfileStart()
    }
    pushGTMUserInfo()
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.currentUser && this.props.currentUser) {
      this.props.loadProfileStart()
    }
  }

  render() {
    const {
      children,
      isAuthenticated,
      currentUser,
      isCurrentUserLoading,
      locationId,
      profile,
      match,
      nav,
      showSubNav,
      history,
      requestCount,
    } = this.props
    return (
      <>
        {isCurrentUserLoading ? (
          <SimpleSpinner />
        ) : (
          <>
            <Header
              avatarId={profile && profile.avatarId}
              currentUser={currentUser}
              history={history}
              isAuthenticated={isAuthenticated}
              isCurrentUserLoading={isCurrentUserLoading}
              locationId={locationId}
              logout={logoutStart}
              match={match}
              profileStatus={profile && profile.status}
              requestCount={requestCount}
              showOffersButton
              showSubNav={showSubNav}
              toggleContentCards={this.toggleContentCards}
            />
            {/* will only render if passed in on props */}
            {renderNav({
              NavContent: nav,
              locationId,
              match: this.props.match,
            })}
          </>
        )}
        <article
          id="content"
          style={{
            paddingTop: '32px',
            paddingBottom: '32px',
            // minHight 100vh minus header and footer
            minHeight: 'calc(100vh - 287px)',
          }}
        >
          {children}
        </article>
        <Footer isAuthenticated={isAuthenticated} showLogo="true" />
      </>
    )
  }
}

const renderNav = ({ NavContent, ...rest }) => {
  if (!NavContent) {
    return null
  }

  return React.isValidElement(NavContent) ? (
    NavContent
  ) : (
    <NavContent {...rest} />
  )
}

const mapStateToProps = state => {
  const { isAuthenticated, currentUser, isCurrentUserLoading } = state.user
  const locationId = selectUserLocationId(state)
  const { profile } = state.profile

  return {
    isAuthenticated,
    currentUser,
    isCurrentUserLoading,
    locationId,
    profile,
  }
}

const mapDispatchToProps = {
  logoutStart,
  currentUserStart,
  loadProfileStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(LayoutOneCol)
